module.exports = __webpack_public_path__ + "img/dobby_brand_logo.cd29d481.png";